export default __webpack_public_path__ + "static/media/Annual-Lecture-Series-2006-2017.1ea162dd.pdf";